import type { StringIndexedObject } from '@kanda-libs/ks-component-ts';
import { createContext } from 'react';

export interface LineItemContextValue {
  price?: number;
  quantity?: number;
  title?: string;
  total?: number;
  vat?: number;
  isLoading?: boolean;
  description?: string;
  quoteDocument?: {
    name: string;
  };
  classNames: StringIndexedObject;
  style?: string;
  onQuoteDocumentClick?: () => void;
  isSubmitting: boolean;
}

const Context = createContext<LineItemContextValue>({
  classNames: {},
  isSubmitting: false,
});

Context.displayName = 'LineItem-Context';

export default Context;
